<template>
  <div id="index">
    <header class="am-topbar">
      <OffCanvas class="meun">边侧栏</OffCanvas>
      <div class="logo-wrapper">
        <div class="logo"></div>
      </div>
    </header>
    <!--广告轮播-->
    <div class="am-slider am-slider-default">
      <ul class="am-slides">
        <li @click="openApp(2)">
          <img src="./业务办理广告@3x.png" class="am-img-responsive"/>
        </li>

        <li @click="openApp(0)">
          <img src="./开户广告@3x.png" class="am-img-responsive"/>
        </li>
      </ul>
    </div>
    <!--功能列表-->
    <div class="gnlb">
      <div class="am-g">
        <div class="am-u-sm-6" @click="openApp(0)">
          <div class="qhkh"></div>
          <div class="gnlb_title">期货开户</div>
        </div>
        <div class="am-u-sm-6" @click="goToDownload">
          <div class="qhjy"></div>
          <div class="gnlb_title">期货交易</div>
        </div>
        <div class="am-u-sm-6" @click="openApp(0)">
          <div class="flcx"></div>
          <div class="gnlb_title">费率查询</div>
        </div>
        <div class="am-u-sm-6" @click="openApp(2)">
          <div class="ywbl"></div>
          <div class="gnlb_title">业务办理</div>
        </div>
        <div class="am-u-sm-6" @click="openApp(1)">
          <div class="lhmj"></div>
          <div class="gnlb_title">蓝海密剑</div>
        </div>
        <div class="am-u-sm-6" @click="$router.push({name: 'zcgl', params: {nr: 'login'}})">
          <div class="zcgl"></div>
          <div class="gnlb_title">资产管理</div>
        </div>
      </div>
    </div>
    <!--公告-->
    <div class="gsgg">
      <div class="top">
        <div class="icon"></div>
        <span @click='tabToggle("gsgg");' :class="{ active: currentView==='gsgg' }">公司公告</span>
        <span @click='tabToggle("jys");' :class="{ active: currentView==='jys' }">交易所公告</span>
        <span @click='tabToggle("bzj");' :class="{ active: currentView==='bzj' }">保证金公告</span>
      </div>
      <div>
        <List v-show="currentView=='gsgg'" :list="gsgg" name="gsgg" :ShowTime="true" :count=5></List>
        <List v-show="currentView=='jys'" :list="jys" name="jys" :ShowTime="true" :count=5></List>
        <List v-show="currentView=='bzj'" :list="bzj" name="bzj" :ShowTime="true" :count=5></List>
      </div>
      <div class="ShowMore" style="display: inherit">
        <router-link :to="{ name: 'gg', params: { nr: currentView }}">点击查看更多</router-link>
      </div>
    </div>
    <!--常见问题-->
    <div class="cjwt">
      <div class="cjwttitle">
        <div class="icon"></div>
        <span><router-link :to="{ name: 'cjwt'}">常见问题</router-link></span>
      </div>
      <List :list="zzwd" name="cjwt" :count=5></List>
      <div class="ShowMore" style="display: inherit">
        <router-link :to="{ name: 'cjwt'}">点击查看更多</router-link>
      </div>
    </div>
    <ICP></ICP>
  </div>
</template>

<script>
import OffCanvas from '@/components/OffCanvas/OffCanvas'
import ICP from '@/components/ICP/ICP'
import ShowMore from '@/components/ShowMore/ShowMore'
import List from '@/components/list/List'
import ajax from '@/common/ajax/ajax'

export default {
  name: 'index',
  data () {
    return {
      zzwd: [],
      zzwdShow: 5,
      gsgg: [],
      jys: [],
      bzj: [],
      currentView: 'gsgg',
      appurl: [
        {
          name: '东航金融APP首页',
          android: 'kiiikmobile://start.home',
          ios: 'mobileplatform://HTML_FirstPage',
          downloadurl: 'http://m.cesfutures.com/kiiikweixin/apppro/phoned.jsp'
        }, {
          name: '东航金融APP蓝海密剑首页',
          android: 'kiiikmobile://start.home?pagename=LHMJ',
          ios: 'mobileplatform://HTML_LHMJ',
          downloadurl: 'http://m.cesfutures.com/kiiikweixin/apppro/phoned.jsp'
        }, {
          name: '东航金融APP业务办理页面',
          android: 'kiiikmobile://start.home?pagename=YWBL',
          ios: 'mobileplatform://HTML_YWBL',
          downloadurl: 'http://m.cesfutures.com/kiiikweixin/apppro/phoned.jsp'
        }, {
          name: '掌控全球',
          android: 'kiiikapp://trade.kiiik.com/',
          ios: 'GlobalHawk://',
          downloadurl: 'http://www.cesfutures.com/h5/zkqq_download/index.html'
        }
      ]
    }
  },
  created: function () {
    ajax.getZzwdlist().then(
      data => {
        this.zzwd = data
      }
    )
    ajax.getGsgglist().then(
      data => {
        this.gsgg = data
      }
    )
    ajax.getJyslist().then(
      data => {
        this.jys = data
      }
    )
    ajax.getBzjlist().then(
      data => {
        this.bzj = data
        this.bzj.forEach(function (value) {
          value.title = value.title.replace('-', '年').replace('-', '月') + '日保证金调整公告'
        })
      }
    )
  },
  mounted: function () {
    $('.am-slider').flexslider()
  },
  components: {
    OffCanvas,
    ICP,
    ShowMore,
    List
  },
  methods: {
    goToDownload () {
      this.$router.push('zkqq')
    },
    tabToggle: function (tabText) {
      this.currentView = tabText
    },
    openApp: function (index) {
      let u = navigator.userAgent
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      if (isAndroid) {
        document.location = this.appurl[index].android
      }
      if (isiOS) {
        document.location = this.appurl[index].ios
      }
      setTimeout(() => {
        document.location = this.appurl[index].downloadurl
      }, 1000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/common.styl"
  .am-direction-nav
    display none

  #index
    .ShowMore
      display none
    .logo-wrapper
      display: inline-block
      padding-top 13.5px
      .logo
        margin auto
        bg-image('logo', 70px, 18px)
        vertical-align inherit
    .am-slider
      margin-bottom 40px
      .am-slides
        .gg1
          bg-image('开户广告', 375px, 175px)
        .gg2
          bg-image('业务办理广告', 375px, 175px)
        .gg3
          bg-image('掌控全球广告', 375px, 175px)
      .am-direction-nav
        display none
      .am-control-nav
        bottom 8px
        li
          margin 0 3.5px
          a
            background-color rgba(255, 255, 255, .4)
            &.am-active
              background-color #fff

    .gnlb
      padding 0 $bj 0 $bj
      text-align center
      .am-u-sm-6
        padding-top 25px
        &:nth-child(odd)
          border-right solid 1px #cccccc
        &:nth-child(-n+4)
          border-bottom solid 1px #cccccc
      .qhkh
        bg-image('期货开户icon', 64px, 64px)
      .qhjy
        bg-image('期货交易icon', 64px, 64px)
      .flcx
        bg-image('费率查询icon', 64px, 64px)
      .ywbl
        bg-image('业务办理icon', 64px, 64px)
      .lhmj
        bg-image('蓝海密剑icon', 64px, 64px)
      .zcgl
        bg-image('资产管理icon', 64px, 64px)
      .gnlb_title
        margin-top 14px
        margin-bottom 25px
        font-size $font_size4
        color #000
    .gsgg
      margin-top 40px
      background-color #ebedf1
      padding 0 $bj 0.1px $bj
      .top
        font-size 15px
        line-height 15px
        padding-top 28px
        .icon
          bg-image('公告icon', 18px, 18px)
          vertical-align bottom
          margin-right 13px
        span
          color $font_color5
          margin-right 25px
          &.active
            color #a88b6b
    .cjwt
      padding 0 $bj 0 $bj
      .cjwttitle
        margin-top 27px
        color $font_color4
        font-size $font_size2
        line-height $font_size2
        .icon
          bg-image('常见问题icon', 18px, 18px)
          vertical-align bottom
          margin-right 13px
      .List
        margin-top 11px
        ul
          li
            line-height 41px
            font-size 13px
            color $font_color1
            margin-left 28px
            border-bottom solid 1px #cccccc

</style>



// WEBPACK FOOTER //
// index.vue?d05a3932